import React from 'react';
import Feather from '@expo/vector-icons/Feather';
import Ionicons from '@expo/vector-icons/Ionicons';
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';
import { Paprika } from '../../styles/theme';
import { CategoryIconRef } from './categoryMeta';
import { ZoneIconRef } from './zoneMeta';

type IconRef = CategoryIconRef | ZoneIconRef;

interface Props {
  icon: IconRef;
  size?: number;
  color?: string;
}

export function PantryIcon({ icon, size = 24, color }: Props) {
  const iconColor = color ?? Paprika.textPrimary;
  switch (icon.lib) {
    case 'feather':
      return <Feather name={icon.name as any} size={size} color={iconColor} />;
    case 'ion':
      return <Ionicons name={icon.name as any} size={size} color={iconColor} />;
    case 'mci':
      return <MaterialCommunityIcons name={icon.name as any} size={size} color={iconColor} />;
  }
}
